import { TextInput } from '../../../../components/TextInput';
import { formatMoneyString } from './money';

/**
 * Exactly one name: a visible label, or -- where a table header labels the field visually --
 * an aria-label. Neither would leave the input unnamed; both would have two names that can drift.
 */
type MoneyInputName =
  | { label: string; ariaLabel?: never }
  /** Names the field for a screen reader where a table header labels it visually instead. */
  | { ariaLabel: string; label?: never };

type MoneyInputProps = MoneyInputName & {
  value: string;
  onChange: (next: string) => void;
  disabled?: boolean;
  placeholder?: string;
};

export const MoneyInput = ({
  label,
  ariaLabel,
  value,
  onChange,
  disabled,
  placeholder,
}: MoneyInputProps) => (
  <TextInput
    label={label}
    aria-label={ariaLabel}
    type="text"
    inputMode="decimal"
    value={value}
    onChange={(e) => onChange(formatMoneyString(e.target.value))}
    disabled={disabled}
    placeholder={placeholder}
    // Money on a roster row is never the coach's own card or salary, so autofill has nothing
    // useful to offer here either.
    autoComplete="off"
  />
);
